import * as braze from '@braze/web-sdk';
import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { initPageCall, trackPage } from 'Utils/Analytics';
import { trackPageSource } from 'State/Tracking/TrackingActions';
import { getPathRoot } from 'Utils/Braze';

const Tracking = ({ title, location, eventName, children }) => {
  const firstPageCall = useRef(true);
  const dispatch = useDispatch();

  useEffect(() => {
    const { state, pathname } = location;
    const pageSource = (state && state.page_source) || null;
    if (pageSource) dispatch(trackPageSource(pageSource));

    if (title && location) {
      if (firstPageCall.current) {
        initPageCall(title, location.pathname, eventName);
        firstPageCall.current = false;
      } else {
        trackPage(title, location.pathname, eventName);
      }
    }

    const pathRoot = getPathRoot(pathname);
    braze.logCustomEvent('Page_Load', {
      path: pathname,
      pathRoot,
    });
  }, [dispatch, location, title, eventName]);

  return children;
};

export default Tracking;
